import request from '@/utils/request'

// 获取我的班级
export function getMyExercisesClass(userId) {
    return request({
        url: '/hdjg/exam-class/getExamClass?userId=' + userId,
        method: 'get'
    })
}

//根据班级id获取课程
export function getCoursesByClassIdWithWrapper(classId) {
    return request({
        url: '/hdjg/exam-class/getCoursesByClassIdWithWrapper?classId=' + classId,
        method: 'get'
    })
}
